<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-12 nopads list-container">
        <div v-if="resultList.length > 0" class="list-content result-table" :class="{nopads : noPadding}">
            <vue3-datatable
                :rows="resultList"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                :height="resultList.length > 8 ? '50vh' : '100%'"
                :sortable="true"
                :sort-column="sortBy"
                :sort-direction="sortDirection"
                skin="bh-table-compact"
                :row-class="getRowClass"
                cell-class="routa-table-cell"
                @row-click="rowClicked"
            >
                <template #created_at="row">
                    {{ row.value && row.value.created_at ? getDateString(row.value.created_at) : '' }}
                </template>
                <template #cost="row">
                    {{ row.value.cost.toFixed(2) }}{{ currency }}
                </template>
            </vue3-datatable>
        </div>
    </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {additionalCostHelper, additionalCostStatus} from "@/components/mixins/AdditionalCostMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'additional-cost-list',
    components: {Vue3Datatable},
    mixins: [timeUtils, additionalCostHelper],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        noPadding: {
            type: Boolean,
            default: false
        },
        tableSortable: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            sortBy: 'created_at',
            sortDirection: "desc",
            fields: [
                {field: 'created_at', title: this.$t('additional_cost.created_at'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('additional_cost.type'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'amount', title: this.$t('additional_cost.amount'), sort: this.tableSortable, headerClass: 'routa-table-header', type: 'number'},
                {field: 'unit', title: this.$t('additional_cost.unit'), sort: this.sortable, tableSortable: 'routa-table-header'},
                {field: 'unit_price', title: this.$t('additional_cost.unit_price'), sort: this.tableSortable, headerClass: 'routa-table-header', type: 'number'},
                {field: 'contract', title: this.$t('additional_cost.contract'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'company', title: this.$t('common.company'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'work_order', title: this.$t('additional_cost.order'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'user', title: this.$t('additional_cost.user'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('additional_cost.status'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'info', title: this.$t('common.info'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'cost', title: this.$t('additional_cost.cost'), sort: this.tableSortable, headerClass: 'routa-table-header', type: 'number'}
            ],
            resultList: []
        }
    },
    computed: {
        currency() {
            return import.meta.env.VITE_APP_CURRENCY || '€'
        }
    },
    watch: {
        results() {
            this.initResults()
        }
    },
    mounted() {
        this.initResults()
    },
    methods: {
        initResults() {
            let temp = []
            this.resultList = []
            this.results.forEach(item =>
                temp.push({
                    'id': item.id,
                    'created_at': item.created_at,
                    'user': item.user ? item.user.first_name + ' ' + item.user.last_name : '',
                    'amount': parseFloat(item.amount) || 0,
                    'unit': item.unit,
                    'unit_price': parseFloat(item.unit_price) || 0,
                    'contract': this.getContractInfo(item),
                    'company': item.user.company ? item.user.company.name : '',
                    'work_order': item.work_order ? this.getOrderInfo(item.work_order) : '',
                    'type': item.type ? this.getAdditionalCostTypeName(item.type) : '',
                    'status': item.status ? this.getAdditionalCostStatusName(item.status) : '',
                    'info': item.info,
                    'cost': parseFloat((item.unit_price * item.amount).toFixed(2)),
                })
            )
            this.$nextTick(() => this.resultList = temp )
        },

        getRowClass(row) {
            switch (row.status) {
                case additionalCostStatus.APPROVED: return 'routa-table-row selected-row'
                case additionalCostStatus.REJECTED: return 'routa-table-row danger-row'
            }
            return 'routa-table-row'
        },

        getContractInfo: function (item) {
            if (item.contract && item.contract.name) {
                return item.contract.name + " (" + item.contract.customer.name + " - " + item.contract.contractor.name + ")"
            } else if (item.work_order && item.work_order.contract) {
                return item.work_order.contract.name + " (" + item.work_order.contract.customer.name + " - " + item.work_order.contract.contractor.name + ")"
            } else {
                return ''
            }
        },
        getOrderInfo: function (order) {
            if (order && order.task_type) {
                return order.task_type.name
            } else {
                return ''
            }
        },
        rowClicked: function (row) {
            const clickedItem = this.results.find(item => item.id === row.id)
            if (clickedItem) {
                this.$emit("rowClicked", clickedItem)
            }
        }
    }
}
</script>
